export const mpaGeneralInfoFormName = "mpaGeneralInfoForm";
export const mpaFeesFormName = "mpaFeesForm";
export const mpaFileMaxSize = 104857600;
